import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { AppSettings } from '../app-settings';

@Injectable({
  providedIn: 'root'
})
export class SeasonPassCategoryService {

  constructor(private http: HttpClient) { }

  /**
   * Catálogo global de categorías de abono (socio, infantil, etc.). No va
   * acotado por compañía: el backend lo expone como lectura abierta para
   * poblar selects. Con `active=true` solo trae las que están en uso.
   */
  getCategories(onlyActive: boolean = true) {
    let url = `${AppSettings.API_URI_V2}/season-pass-categories`;
    if (onlyActive) url += `?active=true`;
    return this.http.get<any>(url).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }
}
